import React from 'react';
import { Select } from 'antd';
import { FilterBar } from '../../../components/list';
import type { CampaignFilterValues, CampaignStatus } from '../types';
import { CAMPAIGN_STATUS_OPTIONS } from '../constants';
import { useLeadSources } from '../../leads/hooks/useLeadSources';

export interface CampaignFilterBarProps {
  value: CampaignFilterValues;
  onChange: (value: CampaignFilterValues) => void;
  onReset: () => void;
}

const CampaignFilterBar: React.FC<CampaignFilterBarProps> = ({
  value,
  onChange,
  onReset,
}) => {
  const { data: sources } = useLeadSources();
  const channelOptions = sources?.filter(s => s.isActive).map(s => ({ value: s.id, label: s.label })) ?? [];

  const handleStatusChange = (v: CampaignStatus | undefined) => {
    onChange({ ...value, status: v });
  };
  const handleChannelChange = (v: number | undefined) => {
    onChange({ ...value, channelId: v });
  };

  const hasActiveFilters = value.status !== undefined || value.channelId !== undefined;

  return (
    <FilterBar onReset={hasActiveFilters ? onReset : undefined}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <span style={{ fontSize: 12, color: 'var(--ant-color-text-tertiary)', lineHeight: '16px' }}>Status</span>
        <Select<CampaignStatus>
          allowClear
          options={CAMPAIGN_STATUS_OPTIONS}
          value={value.status ?? undefined}
          onChange={handleStatusChange}
          style={{ width: 140 }}
        />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <span style={{ fontSize: 12, color: 'var(--ant-color-text-tertiary)', lineHeight: '16px' }}>Channel</span>
        <Select<number>
          allowClear
          options={channelOptions}
          value={value.channelId ?? undefined}
          onChange={handleChannelChange}
          style={{ width: 160 }}
        />
      </div>
    </FilterBar>
  );
};

export default CampaignFilterBar;
